<template>
  <div>
    <mtd-header height="48px">
      <div class="title">数据安全运营平台</div>
    </mtd-header>
    <div v-if="!is_mobile">
      <mtd-row type="flex" class="row-bg" justify="center" v-if="errorCommands">
        <mtd-col :span="6">
          <div class="total-content">
            <div style="text-align: center;font-size: 100px;color: rgb(245, 72, 59)"><mtd-icon name='error-o'></mtd-icon></div>
            <div style="text-align: center;font-size: 20px;font-weight: 500;margin-top: 12px;color: rgba(0,0,0,.87)">该文档无需申诉，请重新确认</div>
          </div>
        </mtd-col>
      </mtd-row>
      <mtd-row type="flex" class="row-bg" justify="center" v-else>
        <mtd-col :xl="6" :lg="12" :md="18" :sm="22" :xs="22">
          <div class="total-content">
            <div style="text-align: center;font-size: 20px;font-weight: 500;margin-top: 12px;color: rgba(0,0,0,.87)">{{ tips }}</div>
            <div style="text-align: center;margin-top: 20px;width: 100%" v-if="chains.length !== 0">
              <mtd-steps :active="0" v-if="!is_mobile" style="justify-content: center;">
                <mtd-step :title="item.approvalName" :description="formatUserData(item.users)" v-for="(item,index) in chains" :key="index"/>
              </mtd-steps>
            </div>
            <div v-if="!submit_flag">
              <div style="margin-top: 20px">
                <mtd-form class="mis-input">
                  <mtd-form-item label="Mis:" :label-width="50" class="mtd-form-item-required">
                    <mtd-select placeholder="请输入并选择人员mis" v-model="submit_form.misId" class="select-width"
                                :filterable="true"  style="width: 100%" clearable
                                :remote="true" :debounce="500" :loading="misid_loading"
                                :remote-method="query_mis">
                      <mtd-option v-for="item in mis_list" :key="item.mis" :label="item.mis"
                                  :value="item.mis"/>
                    </mtd-select>
                  </mtd-form-item>
                </mtd-form>
              </div>
              <div style="margin-top: 20px">
                <mtd-textarea placeholder="请详细填写申请原因，申请更容易通过（必填）"
                              v-model="submit_form.reason" style="width: 100%;"
                              rows="3"/>
              </div>
              <div style="margin-top: 20px;text-align: center">
                <mtd-button type="primary" @click="submit" :loading="submit_loading" :disabled="submitDisabled">提  交</mtd-button>
              </div>
            </div>
            <div v-else>
              <div style="text-align: center;margin-top: 20px;font-size: 16px;color: #999999">
                已经发起审批<br>
                如果长时间未反馈，可大象联系审批人进行催办
              </div>
            </div>
            <div style="margin-top: 16px;text-align: center;" v-if="submit_flag">
              <mtd-button class="btn-demo-item" ghost type="primary" size="large"
                          v-clipboard:copy="url"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onError">复制催办链接</mtd-button>
            </div>
          </div>
        </mtd-col>
      </mtd-row>
    </div>
    <div v-if="is_mobile" class="mobile-container" style="padding: 6px 8px">
      <mtd-form label-position="top">
        <div>
          <mtd-announcement
            :title="tips"
            type="warning"
            show-icon/>
        </div>
        <div style="margin-top: 6px;border-radius: 12px;background-color: #FFFFFF;padding: 8px 8px" v-if="!submit_flag">
          <mtd-form-item label="Mis:" :label-width="50" class="mtd-form-item-required">
            <mtd-select placeholder="请输入并选择人员mis" v-model="submit_form.misId" class="select-width"
                        :filterable="true"  style="width: 100%" clearable
                        :remote="true" :debounce="500" :loading="misid_loading"
                        :remote-method="query_mis">
              <mtd-option v-for="item in mis_list" :key="item.mis" :label="item.name + '/' + item.mis"
                          :value="item.mis"/>
            </mtd-select>
          </mtd-form-item>
          <mtd-form-item label="申请原因" class="mtd-form-item-required">
            <mtd-textarea placeholder="请详细填写申请原因，申请更容易通过（必填）"
                          v-model="submit_form.reason" style="width: 100%;"
                          rows="5"/>
          </mtd-form-item>
        </div>
        <div v-if="submit_flag" style="margin-top: 6px;border-radius: 12px;background-color: #FFFFFF;padding: 8px 8px">
          <div class="shenpi-icon"><mtd-icon name='time'></mtd-icon></div>
          <div class="shenpi-text">
            已经发起审批，请关注大象的审批中心消息<br>
            如果长时间未反馈，可大象联系审批人进入审批详情页催办
          </div>
        </div>
        <div style="margin-top: 8px;text-align: center;" v-if="submit_flag">
          <mtd-button class="btn-demo-item" ghost type="primary" size="large"
                      style="width: 95%;border-radius: 8px"
                      v-clipboard:copy="url"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError">复制催办链接</mtd-button>
          <div style="margin-top: 8px;border-radius: 12px;background-color: #FFFFFF;padding: 8px 8px">
            <div class="complaint-title">
              申诉流程
            </div>
            <mtd-steps :active="0" direction="vertical" :space="80">
              <mtd-step
                :title="item.approvalName"
                :description="formatUserData(item.users)"
                v-for="(item,index) in chains" :key="index" />
            </mtd-steps>
          </div>
        </div>
        <div style="margin-top: 12px;align-items: center;height: 80px" v-if="!submit_flag">
          <mtd-row type="flex" justify="center">
            <mtd-col :span="20">
              <mtd-button class="btn-demo-item" type="primary" style="width: 100%"
                          @click="submit" :loading="submit_loading"
                          :disabled="submitDisabled">提交</mtd-button>
            </mtd-col>
          </mtd-row>
        </div>
      </mtd-form>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'
  import sso from '@/utils/sso'

  export default {
    name: "sso_complaint",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
    },
    data() {
      return {
        submit_form: {
          reason: '',
          misId: '',
          contentId: '',
          command: '',
          type: '',
          sourceApplication: "SSO"
        },
        chains: [],
        tips: '',
        errorCommands: false,
        submit_flag: false,
        url: '',
        submit_loading: false,
        is_mobile: false,
        misid_loading: false,
        mis_list: []
      }
    },
    mounted: function () {
      this.isMobile();
      // 获取参数信息
      this.submit_form.misId = this.$route.query.misId;
      this.submit_form.contentId = this.$route.query.contentId;
      this.submit_form.command = this.$route.query.commands;
      // 获取页面配置信息
      this.getPageInfo();
    },

    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      submitDisabled() {
        return this.submit_form.reason.trim() === '' || this.submit_form.misId === '' || this.submit_form.misId == null;
      },
      formatUserData() {
        return function (userList) {
          let users = '';
          for (let i = 0; i < userList.length; i++) {
            let user = userList[i].accountName + "/" + userList[i].mis;
            users += user;
            if (i !== userList.length - 1) {
              users += '、'
            }
          }
          return users;
        };
      }
    },
    methods: {
      ...mapActions([
        'api_create_complaint_logout',
        'api_get_page_info_logout',
        'api_query_org_misid_strict'
      ]),
      query_mis(keyword) {
        let vm = this;
        if (keyword) {
          vm.misid_loading = true;
          vm.api_query_org_misid_strict({keyword}).then(res => {
            vm.mis_list = res.data;
          }).finally(() => {
            vm.misid_loading = false;
          });
        }
      },
      getPageInfo() {
        this.api_get_page_info_logout(this.submit_form).then(res => {
          this.tips = res.data;
        });
      },
      onCopy() {
        this.$mtd.message.success("复制成功");
      },
      onError() {
        this.$mtd.message.error("复制失败");
      },
      logout() {
        sso.logout();
      },
      submit() {
        let vm = this;
        vm.submit_loading = true;
        this.api_create_complaint_logout(vm.submit_form).then(res => {
          if (res.code === 0) {
            vm.$mtd.message.success("提交成功");
            this.submit_flag = true;
            this.chains = res.data.approvalChain;
            this.url = res.data.url;
          } else if (res.code === 400) {
            vm.$mtd.message.error(res.message);
          } else {
            vm.$mtd.message.error("提交失败");
          }
        }).finally(() => {
          vm.submit_loading = false;
        });
      },
      isMobile() {
        this.flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if(this.flag !== null) {
          this.is_mobile = true;
        }
      }
    }
  }
</script>

<style>
  @import "../../styles/main-container.css";
  @import "../../styles/public.css";

  @media screen and (max-width: 750px) {
    .total-content {
      margin-top: 10%;
      width: 100%;
    }
  }
  .shenpi-icon {
    font-size: 80px;
    color: rgba(10,112,245,1);
    text-align: center;
  }

  .shenpi-text {
    text-align: center;
    font-family: PingFang SC, sans-serif;
    font-size: 16px;
    color: rgba(51,51,51,1);
    text-align: center;
    font-weight: 500;
  }

  @media screen and (min-width: 1250px) {
    .total-content {
      margin-top: 40%;
      width: 100%;
    }
  }

  .mobile-container .mtd-form-item-label {
    font-family: PingFang SC, sans-serif;
    font-size: 16px;
    color: #333333;
    line-height: 42px;
    font-weight: 500;
  }

  .mobile-container .mtd-textarea {
    background: #F5F5F5;
    border-radius: 8px;
    border: none;
  }

  .complaint-title {
    height: 40px;
    padding: 0 6px;
    font-size: 16px;
    color: #333333;
    text-align: left;
    line-height: 42px;
    font-weight: 500;
    border-bottom: 1px solid #F5F5F5;
    margin-bottom: 16px;
  }

  @media screen and (max-width: 780px) {
    #app {
      background-color: #F5F5F5;
    }
  }

  .platform-user-dropdown .mtd-dropdown-menu-item {
    padding: 0;
  }

  .platform-user-dropdown .platform-user-info {
    padding: 8px 12px;
    border-bottom: 1px solid #f7f7f7;
    position: relative;
  }

  .platform-user-dropdown .platform-user-info .platform-user-img {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    vertical-align: middle;
    position: absolute;
    top: 17px;
  }

  .platform-user-dropdown .platform-user-info .platform-user-name {
    margin-left: 36px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    display: block;
    line-height: 22px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    cursor: pointer;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item .platform-user-dropdown-link {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) {
    height: 48px;
    line-height: 48px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) i {
    margin-right: 4px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
    vertical-align: middle;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:hover {
    background-color: #f7f7f7;
  }

  .mis-input .mtd-form-item-label {
    text-align: left;
  }
</style>
